import styled from 'styled-components';

import { theme } from "../../configuration";

const Alert = styled.div`
  padding: 10px;
  margin-bottom: 10px;
  background-color: ${theme.colours.alertBackground};
  color: ${theme.colours.alertText};
  border: 1px solid ${theme.colours.alertBorder};
  border-radius: 4px;
  font-size: ${props => props.small && `0.8em`};
`;

export default Alert;

